'use strict';/* global define */define('modules/ui/directives/cmd-enter/index',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
function directive(){return{restrict:'A',scope:{},require:'^?form',link:function link(scope,element,attrs,formController){// jshint validthis:true
// jshint latedef:false
//
if(!attrs.bnCmdEnter&&!formController){return;}element.on('keydown',handleKeyEvent);/**
         * Get the closest out form
         */function closestForm(){var parent=element.parent();while(parent.length&&parent[0].tagName!=='FORM'){parent=parent.parent();}return parent;}/**
         * Handle the key event and check if cmd+enter was triggered
         * @param  {Object} event event
         */function handleKeyEvent(event){// Is CMD+Enter event.
if(event.which===13&&event.metaKey){event.preventDefault();if(attrs.bnCmdEnter){triggerExpression(event);}else{triggerFormEvent();}}}/**
         * Evaluate expression handed into directive
         * @param  {Object} keyEvent keyEvent
         */function triggerExpression(keyEvent){scope.$evalAsync(function changeViewModel(){scope.$eval(attrs.bnCmdEnter,{$event:keyEvent});});}/**
         * Find the closest form and trigger submit event
         */function triggerFormEvent(){closestForm().triggerHandler('submit');}}};}module.exports=directive;});
